(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-book-shop"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const initDropdown = () => {
      const button = document.querySelector('[data-toggle="tags"]');
      const dropdown = document.querySelector('[data-dropdown="tags"]');

      if (!button || !dropdown) {
        return;
      }

      const toggleDropdown = () => {
        dropdown.classList.toggle('is-active');
      };

      button.addEventListener('click', toggleDropdown);
    };

    initDropdown();

    // Sort
    // Save existing sort parameters
    Shopify.queryParams = {};
    if (location.search.length) {
      const params = new URLSearchParams(location.search);
      for (const [key, value] of params) {
        Shopify.queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    }

    // Add existing sort parameters to current URL
    document.querySelector('.sort-by')?.addEventListener('change', function (e) {
      const value = e.currentTarget.value;
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });

    // Add to cart functionality is handled by cart-drawer-trigger.liquid
    // This prevents duplicate event listeners and multiple cart additions
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-events"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Add to cart functionality is handled by cart-drawer-trigger.liquid
    // This prevents duplicate event listeners and multiple cart additions

    // Past events toggle functionality
    const pastEventsToggle = document.querySelector('[data-toggle="show-all"]');
    if (pastEventsToggle) {
      pastEventsToggle.addEventListener('click', async () => {
        const currentState = pastEventsToggle.getAttribute('data-current-state');
        const newState = currentState === 'true' ? 'false' : 'true';

        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                show_all: newState,
              },
            }),
          });

          if (response.ok) {
            // Update button state
            pastEventsToggle.setAttribute('data-current-state', newState);
            if (newState === 'true') {
              pastEventsToggle.classList.add('is-toggled');
            } else {
              pastEventsToggle.classList.remove('is-toggled');
            }

            // Reload the page to show updated results
            window.location.reload();
          }
        } catch (error) {
          console.error('Error updating cart attributes:', error);
        }
      });
    }

    // Sort event products by start date
    const productContainer = document.querySelector('.posts.is-default.is-loading');

    if (productContainer) {
      const products = Array.from(productContainer.children);

      document.querySelector('.search-count').textContent = `${products.length === 0 ? 'No' : products.length} Upcoming Events`;

      // Show the posts container after sorting
      setTimeout(() => {
        productContainer.classList.remove('is-loading');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-workshops"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Add to cart functionality is handled by cart-drawer-trigger.liquid
    // This prevents duplicate event listeners and multiple cart additions

    // Past workshops toggle functionality
    const pastWorkshopsToggle = document.querySelector('[data-toggle="show-all"]');
    if (pastWorkshopsToggle) {
      pastWorkshopsToggle.addEventListener('click', async () => {
        const currentState = pastWorkshopsToggle.getAttribute('data-current-state');
        const newState = currentState === 'true' ? 'false' : 'true';

        try {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                show_all: newState,
              },
            }),
          });

          if (response.ok) {
            // Update button state
            pastWorkshopsToggle.setAttribute('data-current-state', newState);
            if (newState === 'true') {
              pastWorkshopsToggle.classList.add('is-toggled');
            } else {
              pastWorkshopsToggle.classList.remove('is-toggled');
            }

            // Reload the page to show updated results
            window.location.reload();
          }
        } catch (error) {
          console.error('Error updating cart attributes:', error);
        }
      });
    }

    // Sort workshop products by start date
    const productContainer = document.querySelector('.posts.is-default.is-loading');

    if (productContainer) {
      const products = Array.from(productContainer.children);

      document.querySelector('.search-count').textContent = `${products.length === 0 ? 'No' : products.length} Upcoming Classes`;

      // Show the posts container after sorting
      setTimeout(() => {
        productContainer.classList.remove('is-loading');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const initDropdown = () => {
      const button = document.querySelector('[data-toggle="tags"]');
      const dropdown = document.querySelector('[data-dropdown="tags"]');

      if (!button || !dropdown) {
        return;
      }

      const toggleDropdown = () => {
        dropdown.classList.toggle('is-active');
      };

      button.addEventListener('click', toggleDropdown);
    };

    initDropdown();

    // Sort
    // Save existing sort parameters
    Shopify.queryParams = {};
    if (location.search.length) {
      const params = new URLSearchParams(location.search);
      for (const [key, value] of params) {
        Shopify.queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    }

    // Add existing sort parameters to current URL
    document.querySelector('.sort-by')?.addEventListener('change', function (e) {
      const value = e.currentTarget.value;
      Shopify.queryParams.sort_by = value;
      location.search = new URLSearchParams(Shopify.queryParams).toString();
    });

    // Add to cart functionality is handled by cart-drawer-trigger.liquid
    // This prevents duplicate event listeners and multiple cart additions
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('gform_4');
    const submitButton = document.querySelector('.gform_button');
    const submitMessage = document.querySelector('.submit-message');
    const emailInput = document.getElementById('input_4_1');

    // Hide submit message initially
    submitMessage.style.display = 'none';

    // Enable form
    form.style.pointerEvents = 'auto';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      // Show loading state
      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';
      submitMessage.style.display = 'block';
      submitMessage.textContent = 'Submitting...';

      const url = 'https://c4ba.netlify.app/api/proxy';
      // Collect form data
      const formData = new FormData(form);
      const data = {};

      for (const [key, value] of formData.entries()) {
        data[key] = value;
      }

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          const result = await response.json();

          if (result.data && result.data.is_valid) {
            submitMessage.textContent = 'Thank you for subscribing!';
            submitMessage.style.color = '#4CAF50';
            emailInput.value = '';
            form.style.pointerEvents = 'none';
          } else {
            throw new Error('Form validation failed');
          }
        } else {
          throw new Error('Submission failed');
        }
      } catch (error) {
        console.error('Newsletter submission error:', error);
        submitMessage.textContent = 'Sorry, there was an error. Please try again.';
        submitMessage.style.color = '#f44336';
      } finally {
        // Reset button state
        setTimeout(() => {
          submitButton.disabled = false;
          submitButton.textContent = 'Submit';
          submitMessage.style.display = 'none';
        }, 3000);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // desktop menu
    const moreButton = document.querySelector('.header .more-button a');
    const lessButton = document.querySelector('.header .less-button a');

    moreButton?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      moreButton.parentElement.classList.add('is-open');
      lessButton.parentElement.classList.add('is-open');
    });
    lessButton?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      moreButton.parentElement.classList.remove('is-open');
      lessButton.parentElement.classList.remove('is-open');
    });

    // mobile menu
    const menuButton = document.querySelector('.menu-button');
    const mobileNav = document.querySelector('.header');

    menuButton?.addEventListener('click', () => {
      if (mobileNav.classList.contains('is-open')) {
        // close
        document.body.classList.remove('menu-is-open');
        mobileNav.classList.remove('is-open');
        menuButton.innerHTML = 'Menu';
      } else {
        // open
        document.body.classList.add('menu-is-open');
        mobileNav.classList.add('is-open');
        menuButton.innerHTML = 'Close';
      }
    });

    // cart drawer triggers
    const cartDrawerTriggers = document.querySelectorAll('.cart-drawer-trigger');

    cartDrawerTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (window.cartDrawer) {
          window.cartDrawer.open();
        }
      });
    });

    // Search modal functionality
    const searchButtons = document.querySelectorAll('.header--buttons a[href="/search"]');
    const searchModal = document.querySelector('.search-modal');
    const searchInput = document.querySelector('.search-modal .search-input');

    // Toggle search modal (works for both mobile and desktop)
    searchButtons.forEach((searchButton) => {
      searchButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (searchModal.classList.contains('is-open')) {
          // Close modal
          searchModal.classList.remove('is-open');
          document.body.classList.remove('search-modal-open');
        } else {
          // Open modal
          searchModal.classList.add('is-open');
          document.body.classList.add('search-modal-open');
          // Focus the search input
          setTimeout(() => {
            searchInput?.focus();
          }, 100);
        }
      });
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.classList.contains('is-open')) {
        searchModal.classList.remove('is-open');
        document.body.classList.remove('search-modal-open');
      }
    });

    // Close on click outside
    searchModal?.addEventListener('click', (e) => {
      if (e.target === searchModal) {
        searchModal.classList.remove('is-open');
        document.body.classList.remove('search-modal-open');
      }
    });

    // Handle search form submission
    const searchForm = document.querySelector('.search-modal form');
    searchForm?.addEventListener('submit', (e) => {
      e.preventDefault();
      const query = searchInput.value.trim();
      if (query) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    });

    // Remove show_all from cart attributes when clicking header links
    const headerLinks = document.querySelectorAll('.header a[href]:not([href="/search"]):not([href^="#"])');

    headerLinks.forEach((link) => {
      link.addEventListener('click', async (event) => {
        event.preventDefault();

        if (document.body.hasAttribute('data-show-all')) {
          try {
            // Remove the show_all attribute from cart
            const updateResponse = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                attributes: {
                  show_all: null,
                },
              }),
            });

            if (updateResponse.ok) {
              // Update the cart object if it exists
              if (window.cart) {
                const updatedCart = await updateResponse.json();
                window.cart.attributes = updatedCart.attributes;
              }
            }
          } catch (error) {
            console.error('Error handling cart update:', error);
          }
        }

        // Navigate to the original destination
        window.location.href = link.href;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // Initialize Swiper.js for product image gallery
  document.addEventListener('DOMContentLoaded', () => {
    const productArticle = document.querySelector('article.post');
    const priceDisplays = productArticle?.querySelectorAll('[data-product-price]');
    const availabilityRow = productArticle?.querySelector('[data-availability-row]');
    const availabilityDisplay = productArticle?.querySelector('[data-availability-count]');
    const variantPicker = productArticle?.querySelector('.variants');
    const addToCartButtons = productArticle?.querySelectorAll('.add-to-cart');

    const updateDisplayedVariantDetails = (input) => {
      if (!input) return;

      const nextPrice = input.dataset.priceDisplay;
      if (priceDisplays && nextPrice) {
        priceDisplays.forEach((el) => {
          el.textContent = nextPrice;
        });
      }

      const nextCtaLabel = input.dataset.ctaLabel;
      if (addToCartButtons && nextCtaLabel) {
        addToCartButtons.forEach((btn) => {
          btn.textContent = nextCtaLabel;
        });
      }

      if (!availabilityRow || !availabilityDisplay) return;

      const nextAvailability = input.dataset.availabilityDisplay;
      if (nextAvailability) {
        availabilityDisplay.textContent = nextAvailability;
        availabilityRow.hidden = false;
      } else {
        availabilityRow.hidden = true;
      }
    };

    if (variantPicker) {
      const selectedInput = variantPicker.querySelector('input[name="id"]:checked, select[name="id"]');
      if (selectedInput instanceof HTMLSelectElement) {
        updateDisplayedVariantDetails(selectedInput.selectedOptions[0]);
      } else {
        updateDisplayedVariantDetails(selectedInput);
      }

      variantPicker.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;
        if (target.name !== 'id') return;

        if (target instanceof HTMLSelectElement) {
          updateDisplayedVariantDetails(target.selectedOptions[0]);
          return;
        }

        updateDisplayedVariantDetails(target);
      });
    }

    // Initialize Swiper
    let productSwiper;
    const swiperContainer = document.querySelector('.swiper-container');

    const handleOpen = (e) => {
      e.preventDefault();
      swiperContainer.classList.add('is-lightbox');
      // trigger swiper refresh
      if (productSwiper) productSwiper.update();
    };

    productSwiper = new Swiper(swiperContainer, {
      centeredSlides: true,
      slidesPerView: 1,
      slideToClickedSlide: true,
      // coverflow stuff
      effect: 'coverflow',
      coverflowEffect: {
        depth: 1200,
        modifier: 1,
        rotate: 50,
        slideShadows: false,
        stretch: 0,
      },
      on: {
        init: () => {
          // add click event listener to active slide
          setTimeout(() => {
            const activeSlide = document.querySelector('.swiper-slide-active');
            activeSlide.addEventListener('click', handleOpen);
          });
        },
        // only open lightbox on active slide
        slideChange: () => {
          document.querySelectorAll('.swiper-slide').forEach((slide) => slide.removeEventListener('click', handleOpen));
          // queue to wait for active slide to be updated
          setTimeout(() => {
            const activeSlide = document.querySelector('.swiper-slide-active');
            activeSlide.addEventListener('click', handleOpen);
          });
        },
      },
    });

    const closeBtn = document.createElement('button');
    closeBtn.classList.add('close-lightbox');
    swiperContainer.prepend(closeBtn);

    const handleClose = (e) => {
      e.preventDefault();
      swiperContainer.classList.remove('is-lightbox');
      // trigger swiper refresh
      if (productSwiper) productSwiper.update();
    };

    closeBtn.addEventListener('click', handleClose);
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        handleClose(e);
      }
    });

    // Add to cart functionality is handled by cart-drawer-trigger.liquid
    // This prevents duplicate event listeners and multiple cart additions

    // Handle quantity buttons
    const minusButton = document.querySelector('.minus');
    const plusButton = document.querySelector('.plus');
    const quantityInput = document.querySelector('.quantity-value');

    if (minusButton && plusButton && quantityInput) {
      minusButton.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value) || 1;
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });

      plusButton.addEventListener('click', () => {
        const currentValue = parseInt(quantityInput.value) || 1;
        quantityInput.value = currentValue + 1;
      });
    }

    // Mobile sticky CTA bar proxies the real form's submit button
    const mobileCtaProxy = document.querySelector('.mobile-cta-proxy');
    const realSubmitButton = document.querySelector('.purchase-form button[type="submit"].add-to-cart');
    if (mobileCtaProxy && realSubmitButton) {
      mobileCtaProxy.addEventListener('click', () => {
        realSubmitButton.click();
      });
    }

    // Web Share API implementation
    const shareToggle = document.querySelector('.share-toggle');

    if (shareToggle && navigator.share) {
      shareToggle.addEventListener('click', async (e) => {
        e.preventDefault();

        try {
          const shareData = {
            title: document.title,
            text: document.querySelector('meta[name="description"]')?.content || '',
            url: window.location.href,
          };

          await navigator.share(shareData);
        } catch (error) {
          console.log('Share cancelled or failed:', error);
        }
      });
    } else if (shareToggle) {
      // Fallback for browsers that don't support Web Share API
      shareToggle.addEventListener('click', (e) => {
        e.preventDefault();

        // Fallback to copying URL to clipboard
        if (navigator.clipboard) {
          navigator.clipboard
            .writeText(window.location.href)
            .then(() => {
              // Show a temporary message
              // create a new div element, with absolute positioning, and the text "Link copied!"
              const message = document.createElement('div');
              message.textContent = 'Link copied!';
              message.classList.add('share-toggle-message');
              shareToggle.appendChild(message);

              setTimeout(() => {
                // fade out
                message.style.opacity = '0';
                setTimeout(() => {
                  message.remove();
                }, 1000);
              }, 2000);
            })
            .catch((err) => {
              console.error('Failed to copy URL:', err);
            });
        } else {
          // Fallback for older browsers
          alert('Share this URL: ' + window.location.href);
        }
      });
    }

    // Clean up pay-what-you-can variant labels
    const payWhatYouCanLabels = document.querySelectorAll('.variant-radio-label.pay-what-you-can');
    payWhatYouCanLabels.forEach(label => {
      const originalTitle = label.dataset.originalTitle;
      const price = label.dataset.price;

      // Remove any price pattern from the title using regex
      const cleanTitle = originalTitle.replace(/\s*-\s*\$\d+|\s*\$\d+/g, '').trim();

      // Update the label with clean title and correct price
      label.textContent = `${cleanTitle} ${price}`;
      label.style.visibility = 'visible';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // Handle add to cart functionality for search page
  document.addEventListener('DOMContentLoaded', () => {
    // Add to cart functionality is handled by cart-drawer-trigger.liquid
    // This prevents duplicate event listeners and multiple cart additions

    // Load more functionality
    document.querySelectorAll('.show-all-results').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const section = btn.closest('.search-section');

        // Show all hidden posts
        section.querySelectorAll('.post-item.hidden').forEach((post) => {
          post.classList.remove('hidden');
        });

        // Hide the button
        btn.style.display = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
